import { breakpoint } from './breakpoint';
import { font } from './font';
import { color } from './color';
import { ease } from './ease';
import { grid } from './grid';

export default {
  breakpoint,
  font,
  color,
  ease,
  grid,
};
